/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OneTimeAccessTokenSharedObject
 */
export interface OneTimeAccessTokenSharedObject {
    /**
     * 
     * @type {number}
     * @memberof OneTimeAccessTokenSharedObject
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OneTimeAccessTokenSharedObject
     */
    name: string;
}

export function OneTimeAccessTokenSharedObjectFromJSON(json: any): OneTimeAccessTokenSharedObject {
    return OneTimeAccessTokenSharedObjectFromJSONTyped(json, false);
}

export function OneTimeAccessTokenSharedObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): OneTimeAccessTokenSharedObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OneTimeAccessTokenSharedObjectToJSON(value?: OneTimeAccessTokenSharedObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


